var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"sm":""}},[_c('label',[_vm._v(_vm._s(_vm.name))]),_c('b-form-group',_vm._l((_vm.items),function(radio,index){return _c('b-form-radio',{key:index,attrs:{"value":radio},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v(_vm._s(radio))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }